var _defs, _rect, _rect2, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLandscapeMock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 400,
    zoomAndPan: "magnify",
    viewBox: "0 0 300 149.999998",
    height: 200,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    id: "11233a1d8e"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0",
    colorInterpolationFilters: "sRGB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b98893d31d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 41.871094 31.25 L 260.683594 31.25 L 260.683594 150 L 41.871094 150 Z M 41.871094 31.25 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "84208be2ec"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 48.621094 31.25 L 253.863281 31.25 C 257.589844 31.25 260.613281 34.273438 260.613281 38 L 260.613281 162.132812 C 260.613281 165.859375 257.589844 168.882812 253.863281 168.882812 L 48.621094 168.882812 C 44.890625 168.882812 41.871094 165.859375 41.871094 162.132812 L 41.871094 38 C 41.871094 34.273438 44.890625 31.25 48.621094 31.25 Z M 48.621094 31.25 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "85e368104a"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#11233a1d8e)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -30,
    width: 360,
    fill: "#000000",
    y: -15,
    height: 179.999997,
    fillOpacity: 0.65
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "2f90c0b2f7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.449219 0.25 L 249.667969 0.25 L 249.667969 25.476562 L 0.449219 25.476562 Z M 0.449219 0.25 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f5585d749b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.199219 0.25 L 242.886719 0.25 C 246.613281 0.25 249.636719 3.273438 249.636719 7 L 249.636719 18.726562 C 249.636719 22.453125 246.613281 25.476562 242.886719 25.476562 L 7.199219 25.476562 C 3.472656 25.476562 0.449219 22.453125 0.449219 18.726562 L 0.449219 7 C 0.449219 3.273438 3.472656 0.25 7.199219 0.25 Z M 7.199219 0.25 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3eac873bc4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 250,
    y: 0,
    height: 26
  })), /*#__PURE__*/React.createElement("mask", {
    id: "cf02460634"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#11233a1d8e)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -30,
    width: 360,
    fill: "#000000",
    y: -15,
    height: 179.999997,
    fillOpacity: 0.65
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "f5db800d88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.417969 0.417969 L 206.097656 0.417969 L 206.097656 71 L 0.417969 71 Z M 0.417969 0.417969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "689e8d08e3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.167969 0.417969 L 199.316406 0.417969 C 203.042969 0.417969 206.066406 3.4375 206.066406 7.167969 L 206.066406 64.25 C 206.066406 67.976562 203.042969 71 199.316406 71 L 7.167969 71 C 3.4375 71 0.417969 67.976562 0.417969 64.25 L 0.417969 7.167969 C 0.417969 3.4375 3.4375 0.417969 7.167969 0.417969 Z M 7.167969 0.417969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a25c478fae"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 207,
    y: 0,
    height: 72
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "860c386a8d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 48.417969 36.675781 L 89.117188 36.675781 L 89.117188 51.050781 L 48.417969 51.050781 Z M 48.417969 36.675781 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "132179c53e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 55.167969 36.675781 L 82.351562 36.675781 C 86.078125 36.675781 89.101562 39.699219 89.101562 43.425781 L 89.101562 44.300781 C 89.101562 48.027344 86.078125 51.050781 82.351562 51.050781 L 55.167969 51.050781 C 51.4375 51.050781 48.417969 48.027344 48.417969 44.300781 L 48.417969 43.425781 C 48.417969 39.699219 51.4375 36.675781 55.167969 36.675781 Z M 55.167969 36.675781 ",
    clipRule: "nonzero"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -30,
    width: 360,
    fill: "#ffffff",
    y: -15,
    height: 179.999997,
    fillOpacity: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -30,
    width: 360,
    fill: "#edeaea",
    y: -15,
    height: 179.999997,
    fillOpacity: 1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b98893d31d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#84208be2ec)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 41.871094 31.25 L 260.683594 31.25 L 260.683594 168.882812 L 41.871094 168.882812 Z M 41.871094 31.25 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#85e368104a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 22, 31)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3eac873bc4)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2f90c0b2f7)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f5585d749b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ededed",
    d: "M 0.449219 0.25 L 249.667969 0.25 L 249.667969 25.476562 L 0.449219 25.476562 Z M 0.449219 0.25 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cf02460634)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 48, 64)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a25c478fae)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f5db800d88)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#689e8d08e3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#59a3ff",
    d: "M 0.417969 0.417969 L 206.097656 0.417969 L 206.097656 71 L 0.417969 71 Z M 0.417969 0.417969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#860c386a8d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#132179c53e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d9d9d9",
    d: "M 48.417969 36.675781 L 89.117188 36.675781 L 89.117188 51.050781 L 48.417969 51.050781 Z M 48.417969 36.675781 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandscapeMock);
export default __webpack_public_path__ + "static/media/landscapeMock.55f4ff506ce2d7edf61f7e2844a6edb6.svg";
export { ForwardRef as ReactComponent };